var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "视频预览",
      visible: _vm.visible,
      "destroy-on-close": "",
      width: "90%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("video", {
    staticStyle: {
      width: "100%",
      height: "600px"
    },
    attrs: {
      src: _vm.url,
      controls: "controls"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };